<template>
    <li class="nav-section" v-if="!!item.section">
        <span class="nav-separator"></span>
    </li>
    <nav-child
        :icon="item.icon"
        :title="item.title"
        :link="item.link"
        :active="!!item.current_route"
        v-else
    >
        <nav-ul
            sub="true"
            :items="item.childrens"
            v-if="!!item.childrens && !!item.childrens.length"
        ></nav-ul>
    </nav-child>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: null,
            required: true
        }
    }
};
</script>
